<div class="wrapper--spacing-horizontal page-content">
  <cow-table [selectedMeasurementDate]="selectedDate" />
</div>
